// import AppView from "../app/appView";
// import AppEdit from "../app/appEdit";

// class AppToggle extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { toggleEditMode: false };
//     this.toggleMode = this.toggleMode.bind(this);
//   }
//   toggleMode(val) {
//     this.setState({ toggleEditMode: val });
//   }
//   render() {
//     const message = this.props.message;
//     return (
//       <>
//         {this.state.toggleEditMode ? (
//           <AppEdit message={message} toggleMode={this.toggleMode} />
//         ) : (
//           <AppView message={message} toggleMode={this.toggleMode} />
//         )}
//       </>
//     );
//   }
// }

// export default AppToggle;

import AppView from "../app/appView";
import AppEdit from "../app/appEdit";
import React from "react";
class AppToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggleEditMode: false, appMessage: "", success: false };
    this.toggleMode = this.toggleMode.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.appData = this.appData.bind(this);
  }
  toggleMode(val) {
    this.setState({ toggleEditMode: val });
  }
  appData(val) {
    console.log("value", val);
    this.setState({ appMessage: val });
  }
  showSuccess(val) {
    this.setState({ success: val });
    setTimeout(() => {
      this.setState({ success: false });
    }, 10000);
  }
  render() {
    const message = this.props.message;
    const accessSpecifier = this.props.accessSpecifier;
    return (
      <>
        {this.state.toggleEditMode ? (
          <AppEdit
            message={message}
            toggleMode={this.toggleMode}
            appData={this.state.appMessage}
            success={this.showSuccess}
          />
        ) : (
          <AppView
            message={message}
            toggleMode={this.toggleMode}
            accessSpecifier={accessSpecifier}
            isSuccess={this.state.success}
            appData={this.appData}
          />
        )}
      </>
    );
  }
}

export default AppToggle;
